<template>
	<div class="cents">
		<van-nav-bar :title="this.$t('bmgl')" left-arrow safe-area-inset-top style="background-color: #1ABC9C;"
			@click-left="goto" />
		<div style="padding: 10px;">
			<el-tree class="tree" :data="deptList" :props="defaultProps" node-key='id' @node-click="handleNodeClick" :expand-on-click-node="expand" :highlight-current='highlight'>
				<span class="custom-tree-node" slot-scope="{ node, data }">
				        <span>{{ node.label }}</span>
				        <span style="font-size: 12px;">
							<el-button
							  type="text"
							  size="mini"
							  @click="() => add(node, data)">
							  {{btn1}}
							</el-button>
							
							 <el-button
							   type="text"
							   size="mini"
							   @click="() => edit(node, data)">
							   {{btn2}}
							 </el-button>
							 <el-button
							   type="text"
							   size="mini"
							   @click="() => remove(node, data)">
							   {{btn3}}
							 </el-button>
				        </span>
				      </span>
			</el-tree>
			<popup :title='popTitle' :popState='popState' @popClose='popAddClose' @popConfirm='popAddConfirm' :placeholder='placeholderAdd' :btnTxt="$t('qr')"></popup>
			<popup :title='placeholderedit' :popState='editpopState' @popClose='editpopAddClose' @popConfirm='editpopAddConfirm' :placeholder='placeholderedit' :btnTxt="$t('qr')"></popup>
			<inputpopup :title='placeholderdel' :popState='delpopState' @popClose='delpopAddClose' @popConfirm='delpopAddConfirm' :placeholder='placeholderedit' :namePlaceholder="$t('qsryhm')" :paswodPlaceholder="$t('qsryhmm')" :btnTxt="$t('qr')"></inputpopup>
		</div>
		<!--  :expand-on-click-node='false' 点击箭头才能展示子节点 -->
		<!-- <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" node-key='label'></el-tree> -->
	</div>
</template>

<script>
	import popup from '@/components/singlePopup.vue'
	import inputpopup from '@/components/popupInput.vue'
	import { Toast } from 'vant';
	export default {
		data() {
			return {
				UserInfo: JSON.parse(window.localStorage.getItem("getTokendata")), // 本地缓存 获取用户数据
				deptList: [], // 部门列表
				defaultProps: {
					children: 'children',
					label: 'name'
				},
				expand:false, // 只能点击箭头下拉
				select:{}, // 点击的部门id
				highlight:true, // 高亮
				popState:false,
				popTitle:this.$t('tjzbm'),
				placeholderAdd:this.$t('tjdbmmc'),
				placeholderedit:this.$t('xgmc'),
				editpopState:false,
				placeholderdel:this.$t('bmsc'),
				delpopState:false,
				btn1:this.$t('tj'),
				btn2:this.$t('gm'),
				btn3:this.$t('sc')
			}
		},
		components:{
			popup,
			inputpopup
		},
		mounted() {
			this.getDeptList()
		},
		methods: {
			// 删除
			delpopAddClose(){
				this.delpopState = false
			},
			delpopAddConfirm(e){
				if(e[0]!=''&&e[1]!=''){
					let info = {
						method:'co.dept.del',
						name:e[0],
						password:this.$md5(e[1]),
						id:this.select.id
					}
					this.$https(info).then(res=>{
						if(res.data.code==0){
							Toast.success(this.$t('xgcg'))
							this.deptList = []
							this.getDeptList()
						}else if(res.data.code==-3){
							Toast.fail(this.$t('bmbcz'))
						}else if(res.data.code==-8){
							Toast.fail(this.$t('myqxhzhcw'))
						}else{
							Toast.fail(this.$t('sbhryygl'))
						}
						this.delpopState = false
					})
				}
			},
			// 改名
			editpopAddClose(){
				this.editpopState = false
			},
			editpopAddConfirm(e){
				if(e[0]!=''){
					let info = {
						method:'co.dept.edit',
						name:e[0],
						id:this.select.id
					}
					this.$https(info).then(res=>{
						if(res.data.code==0){
							Toast.success(this.$t('xgcg'))
							this.deptList = []
							
							this.getDeptList()
						}else if(res.data.code==-3){
							Toast.fail(this.$t('bmbcz'))
						}
						this.editpopState = false
					})
				}
			},
			// 添加子部门
			popAddClose(){
				this.popState=false
			},
			popAddConfirm(e){
				console.log(e[0]);
				if(e[0]!=''){
					let info = {
						method:'co.dept.add',
						agent_id:this.UserInfo.agent_id,
						manager_id:this.UserInfo.manager_id,
						name:e[0],
						parent_id:this.select.id
					}
					this.$https(info).then(res=>{
						if(res.data.code==0){
							Toast.success(this.$t('tjcg'))
							this.deptList = []
							
							this.getDeptList()
						}else if(res.data.code==-4){
							Toast.fail(this.$t('yczgwj'))
						}
						this.popState = false
					})
				}
				
			},
			// 改名
			edit(node, data){
				console.log(node, data);
				if(data.is_valid==1){
					Toast.fail(this.$t('gjdbnbcz'))
					return
				}
				this.select = data;
				this.editpopState = true
			},
			// 增加
			add(node, data){
				console.log(node, data);
				if(data.is_valid==1){
					Toast.fail(this.$t('gjdbnbcz'))
					return
				}
				this.popState = true
				this.select = data
			},
			// 删除
			remove(node, data){
				console.log(node, data);
				if(data.is_valid==1){
					Toast.fail(this.$t('gjdbnbcz'))
					return
				}
				this.delpopState = true
				this.select = data
			},
			handleNodeClick(data) {
				console.log(data);
				// this.select = data.id
			},
			// 获取部门列表
			getDeptList() {
				let data = {
					method: 'co.dept.list',
					agent_id: this.UserInfo.agent_id,
					manager_id: this.UserInfo.manager_id
				}
				this.$https(data).then(res => {
					console.log(res)
					for (let key in res.data.data) {
						console.log(res.data.data[key]);
						this.deptList.push(res.data.data[key])
					}
					console.log(this.deptList);
				})
			},
			// 页面返回
			goto() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	.el-tree{
		border: 1px solid #ccc;
	}
	.tree>>>.el-tree-node__content{
		height: 34px;
	}
	.el-button--mini{
		font-size: 14px;
	}
	.tree>>>.custom-tree-node{
		font-size: 18px;
	}
	.tree>>>.el-icon-caret-right{
		font-size: 18px;
	}
	.tree>>>.expanded{
		font-size: 18px;
	}
	.el-tree-node__content>.el-tree-node__expand-icon{
		font-size: 15px;
	}
	.el-icon-caret-right{
		font-size: 15px;
	}
	.custom-tree-node {
	    flex: 1;
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    font-size: 14px;
	    padding-right: 8px;
	  }
	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
